import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Check, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from 'components/ui/dropdown-menu';
import { publicTestCategoryPath, normalizeCategorySlug } from 'modules/test/public-categories';
import { usePublicCategories } from 'modules/test/hooks';
import { catalogCategories } from 'pages/Portal/catalogCategories';
import { cn } from 'lib/utils';
import { portalNavLinkClass } from './navLinkClass';

export function PortalTestsMenu() {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  const active = pathname === '/portal/tests';
  const { data: categoriesData } = usePublicCategories();
  const categoryItems = catalogCategories(categoriesData?.data, t, i18n?.language);

  const currentParam = params.get('category');
  const normalizedParam = normalizeCategorySlug(currentParam);
  const selected =
    categoryItems.find(
      ({ id }) =>
        id.toLowerCase() === normalizedParam ||
        id.toLowerCase() === currentParam?.toLowerCase(),
    )?.id ?? 'all';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={cn(
            portalNavLinkClass(active),
            'data-[state=open]:bg-muted data-[state=open]:text-foreground',
          )}
        >
          {t('portal.tests')}
          <ChevronDown size={14} className="text-muted-foreground/70" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={8} className="w-56">
        {categoryItems.map(({ id, label }) => (
          <DropdownMenuItem key={id} asChild>
            <Link
              to={publicTestCategoryPath(id)}
              aria-current={active && selected === id ? 'page' : undefined}
              className="flex min-h-10 items-center justify-between gap-3"
            >
              {label}
              {active && selected === id && <Check size={15} aria-hidden="true" />}
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
